<template>
  <section>
    <ul>
      <li v-for="item in items" :key="item.id" class="px-24 py-20">
        <NavBurgerMenuItem
          v-if="!item.children.length"
          :color="item.color"
          :icon="item.icon"
          :title="item.title"
          :url="item.url"
          @click-item="toggle"
        />

        <NavBurgerMenuUniverse
          v-else
          :id="item.id"
          :image="item.image"
          :title="item.title"
        >
          <NavBurgerMenuHeader
            :color="item.color"
            :title="item.title"
            @back="clearActiveMenu"
            @close="toggle"
          />
          <section class="overflow-auto pb-32">
            <NavServiceList
              v-for="service in item.details"
              :key="service.name"
              :service
            />
            <div class="flex flex-col gap-12">
              <NavCategoryHeader
                class="mx-24"
                :see-all-url="item.url"
                @click-see-all="toggle"
              />
              <ul
                class="grid grid-cols-1 gap-x-16 gap-y-32 px-24 sm:grid-cols-2 md:grid-cols-3"
              >
                <li v-for="child in item.children" :key="child.id">
                  <NavBurgerMenuCategory
                    :image="child.image"
                    :title="child.title"
                    :url="child.url"
                    @click="toggle"
                  />
                </li>
              </ul>
            </div>
          </section>
        </NavBurgerMenuUniverse>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { useActiveMenu } from '~/scopes/navigation/composables/useActiveMenu'
import { useBurgerMenuState } from '~/scopes/navigation/composables/useBurgerMenuState'
import { useFetchNavigationItems } from '~/scopes/navigation/composables/useFetchNavigationItems'

import NavCategoryHeader from '../shared/NavCategoryHeader.vue'

import NavBurgerMenuCategory from './NavBurgerMenuCategory.vue'
import NavBurgerMenuHeader from './NavBurgerMenuHeader.vue'
import NavBurgerMenuItem from './NavBurgerMenuItem.vue'
import NavBurgerMenuUniverse from './NavBurgerMenuUniverse.vue'
import NavServiceList from './NavServiceList.vue'

const { items } = useFetchNavigationItems()
const { toggle } = useBurgerMenuState()
const { clearActiveMenu } = useActiveMenu()
</script>
